import { render, staticRenderFns } from "./UnfinishedOrders.vue?vue&type=template&id=a41ab1da&"
import script from "./UnfinishedOrders.vue?vue&type=script&lang=js&"
export * from "./UnfinishedOrders.vue?vue&type=script&lang=js&"
import style0 from "./UnfinishedOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports